import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import { css } from "@emotion/core";
const StyledButton = styled.span`
  width: 100%;
  display: block;
  font-size: 1.3rem;
  border-radius: 6px;
  padding: 0.5em;
  text-transform: uppercase;
  color: white;
  width: auto;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  background: #5e6f64;
  color: white;
  border: solid white 1px;
  transition: background-color 0.3s;
  flex: 1 1 10em;

  &:hover {
    background: #393e46;
    transition: 0.3s;
  }
  @media (min-width: 480px) {
    & {
      padding: 1em;
      font-size: 1.5em;
    }
    @media (min-width: 1200px) {
      & {
        padding: 1em;
        font-size: 1.8em;
      }
    }
  }
`;

const Button = ({ to, children }) => {
  return (
    <Link
      css={css`
        flex: 1 1;
      `}
      to={to ? to : "#!"}
    >
      <StyledButton>{children}</StyledButton>
    </Link>
  );
};

export default Button;
